import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  onlineUsers: [],
};

export const sliceWebsocket = createSlice({
  name: 'Websocket',
  initialState,
  reducers: {
    setOnlineUsersList(state, { payload: array }) {
      state.onlineUsers = array;
    },
    addOnlineUser(state, { payload: userId }) {
      if (!state.onlineUsers.includes(userId)) {
        state.onlineUsers.push(userId);
      }
    },
    removeOnlineUser(state, { payload: userId }) {
      state.onlineUsers = state.onlineUsers.filter(el => el !== userId);
    },
  },
});

export const { addOnlineUser, removeOnlineUser, setOnlineUsersList } =
  sliceWebsocket.actions;
export default sliceWebsocket.reducer;
